//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Diagramming.js";
import "../no/TaggedObject.js";
import "../no/LineColorFontWidthBuilder.js";
import "../no/LineColorFontWidthBuilder.js";
let d=[[[0,"ArrowAngle",1,0],[0,"ArrowDirection",1,0],[0,"ArrowHeadTail",1,0],[0,"ArrowLength",1,0],[0,"ArrowStyle",1,0],[0,"BorderLineWidth",1,0],[0,"CenteringMarkLength",1,0],[1,"CenteringMarksColorWidth",0,"LineColorFontWidthBuilder",0],[0,"CenteringMarksExtension",1,0],[0,"CenteringMarksHorizontal",1,0],[0,"CenteringMarksVertical",1,0],[0,"CreateBorders",1,0],[0,"CreateTrimmingMarks",1,0],[0,"DisplaySheetSizeInBorder",1,0],[0,"DistanceFromInnerBorder",1,0],[1,"InnerLineCFW",0,"LineColorFontWidthBuilder",0],[0,"Method",1,0],[1,"OuterLineCFW",0,"LineColorFontWidthBuilder",0],[0,"TrimmingMarkColor",1,0],[0,"TrimmingMarkLength",1,0],[0,"TrimmingMarkStyle",1,0],[0,"TrimmingMarkWidth",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Diagramming.SheetBorderSettingsBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Diagramming.SheetBorderSettingsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;